// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T21:26:26.940Z
// Property: Bull Mountain Heights (ID: 6767906449166802)
// Collections: 22 amenities, 4 floorplans (live), 59 photos, 40 POIs, 6 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166802",
  "property_external_id": "fjgsrft",
  "property_zillow_url": "https://www.zillow.com/apartments/tigard-or/bull-mountain-heights/5gH99J/",
  "property_apartments_url": "https://www.apartments.com/bull-mountain-tigard-or/fjgsrft/",
  "property_google_business_url": "https://www.google.com/maps/place/Bull+Mountain+11430+SW+Bull+Mountain+Rd,+Tigard,+OR+97224,+USA/@45.4142543,-122.7946393,3a,75y,174.98h,90t/data=!3m4!1e1!3m2!1srI_ih6qX3JfMWUCag7MU6A!2e0!4m2!3m1!1s0x54950d4f23dce015:0x825cc513b41d5bd4?sa=X&ved=1t:3780&hl=en&gl=us&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "41652550782",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "561BMT",
  "property_status": null,
  "property_slug": "bull-mountain-heights",
  "property_name": "Bull Mountain Heights",
  "property_website_url": "https://www.bullmountainheights.com/",
  "property_domain": "https://www.bullmountainheights.com/",
  "property_address": "11430 Southwest Bull Mountain Road",
  "property_full_address": "11430 SW Bull Mountain Rd, Tigard, OR 97224",
  "property_address_1": "11430 SW Bull Mountain Rd",
  "property_address_2": null,
  "property_address_city": "Tigard",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97224",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Bull Mountain",
  "property_address_latitude": "45.4139493",
  "property_address_longitude": "-122.7946203",
  "property_email": null,
  "property_phone": "(503) 217-2754",
  "property_call_tracking_phone": "855-343-4167",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Bull Mountain in Tigard, OR, where elegant one, two, and three-bedroom apartments meet a wealth of amenities. Enjoy sunlit spaces, modern finishes, and vibrant community areas, including a refreshing pool and playful dog park. Elevate your lifestyle—view our floor plans and envision your next chapter!",
  "property_long_description": "Welcome to Bull Mountain, your serene oasis in the heart of Tigard, OR! We offer a wide range of stylish floor plans to suit your lifestyle, featuring one, two, and three-bedroom apartments equipped with modern comforts and conveniences. Each residence boasts private bathrooms, walk-in closets, and gourmet kitchens with stainless steel appliances and quartz countertops, ensuring a perfect blend of luxury and functionality.\n\nOur community is designed for both relaxation and recreation. Dive into our sparkling pool, unwind in the hot tub, or challenge yourself in our state-of-the-art fitness center. Families will appreciate the playground and spacious picnic areas, while pet owners can take advantage of our pet play area and dog park. With beautiful walking and biking trails nearby, outdoor enthusiasts will have endless opportunities to explore. \n\nEntertainment and socializing are made easy at our vibrant clubhouse, lounge, and multi-use room, perfect for hosting gatherings with family and friends. With on-site management and maintenance, 24-hour access, and a convenient car wash area, you’ll enjoy peace of mind living at Bull Mountain. \n\nResidents will also benefit from high-speed internet access, washer/dryer units, and smoke-free living, all within a welcoming community that feels like home. Enjoy the beauty of Tigard and discover why Bull Mountain is the ideal place to live.\n\nFind your new home today—browse our availability or schedule a tour to visit our community! Your dream apartment awaits at Bull Mountain.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-193a-764a-b8b1-77ff6a61f865.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment complex office building at dusk with playground nearby.",
    "public_id": "019f3883-193a-764a-b8b1-77ff6a61f865",
    "storage_key": "property/6767906449166802/019f3883-193a-764a-b8b1-77ff6a61f865.webp",
    "width": 3072,
    "height": 2050
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "126",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.03174603174604",
  "property_admin_fee": null,
  "property_application_fee": "65",
  "property_fees_deposit_info": "$300-500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs are allowed, with a maximum of 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs are allowed, with a maximum of 2 pets per unit. Pet deposit: $300 per pet (or $450 total for two). Monthly pet rent: $40 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcbullmountain",
  "property_resident_portal_url": "https://bullmountain.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcbullmountain",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d20b7-aba1-71ca-918b-b26ae383f47d.webp",
  "property_primary_logo_media": {
    "alt_text": "Bull Mountain Heights logo",
    "public_id": "019d20b7-aba1-71ca-918b-b26ae383f47d",
    "storage_key": "property/6767906449166802/019d20b7-aba1-71ca-918b-b26ae383f47d.webp",
    "width": 150,
    "height": 100
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d20b7-b33a-7731-bd46-05cbd751da00.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Bull Mountain Heights logo",
    "public_id": "019d20b7-b33a-7731-bd46-05cbd751da00",
    "storage_key": "property/6767906449166802/019d20b7-b33a-7731-bd46-05cbd751da00.webp",
    "width": 150,
    "height": 100
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d20b7-bc27-774a-8f9b-dcb1bc6b41ad.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Bull Mountain Heights logo",
    "public_id": "019d20b7-bc27-774a-8f9b-dcb1bc6b41ad",
    "storage_key": "property/6767906449166802/019d20b7-bc27-774a-8f9b-dcb1bc6b41ad.webp",
    "width": 150,
    "height": 100
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#111111",
  "property_secondary_color": "#8E9EBC",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "607 - 1,178 sq ft",
  "property_sqft_min": "607",
  "property_sqft_max": "1,178",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "1899",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/bullmountainheights/",
  "property_instagram_url": "https://www.instagram.com/bullmountainh/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFeDcI08NlVQR1FsdtBPFXII",
  "property_youtube_url": "https://www.youtube.com/watch?v=nLN5rRADbBQ",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Hillsboro%2C+OR",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Bull Mountain",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "At Bull Mountain in Tigard, OR, your perfect home awaits! Choose from one, two, or three-bedroom floor plans designed for comfort and style. Enjoy vibrant community amenities, including a refreshing pool, fitness center, and scenic walking trails, all tailored to enhance your lifestyle. Make your dream living a reality!",
  "property_home_floorplans_blurb": "Nestled in the heart of Tigard, OR, Bull Mountain offers thoughtfully designed apartment homes that blend comfort and style. With a variety of unique floor plans tailored to fit every lifestyle, it’s easy to envision your ideal living space. Browse our available options today to find your perfect match!",
  "property_home_gallery_blurb": "At Bull Mountain in Tigard, OR, your dream lifestyle awaits. Choose from spacious one, two, or three-bedroom floor plans, and indulge in amenities like a resort-style pool, a state-of-the-art fitness center, and scenic walking trails. Picture yourself living here and enjoy a vibrant community tailored for relaxation and connection.",
  "property_home_neighborhood_blurb": "<p>Discover a convenient location at Bull Mountain Heights Apartments in Tigard, OR, where shopping, dining, parks, and everyday essentials are all within easy reach. Located along SW Bull Mountain Road, our community provides a convenient starting point for exploring Tigard, Beaverton, and the greater Portland area.</p>",
  "property_home_reviews_blurb": "Welcome to Bull Mountain in Tigard, OR—where comfort meets community! Our residents rave, \"Living here is a dream come true!\" Experience the warmth of our vibrant neighborhood and enjoy top-tier amenities. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Tigard, Bull Mountain offers more than just a place to call home—it’s a gateway to adventure. Enjoy the lush expanses of Tryon Creek State Natural Area, revel in the charm of Fogelbo Historic Log Home, or get active at the nearby heritage and community centers. Uncover the vibrant local culture today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Bull Mountain in Tigard, OR, vibrant living meets convenience. Enjoy our heated pool, state-of-the-art fitness center, and scenic walking trails. With various spacious floor plans including one, two, and three-bedroom apartments, your dream home awaits. Indulge in relaxing cabanas, a pet-friendly playground, and a clubhouse designed for leisure.",
  "property_applynow_blurb": "Welcome to Bull Mountain in Tigard, OR, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a refreshing pool, a state-of-the-art fitness center, and scenic walking trails. Elevate your lifestyle—submit your application today and secure your new home online!",
  "property_contactus_blurb": "At Bull Mountain in Tigard, OR, find the perfect space for every lifestyle with our thoughtfully designed one, two, and three-bedroom floor plans. Each residence harmonizes comfort and style, making it an ideal retreat. Have questions? Our leasing team is just a click away to assist you!",
  "property_faqs_blurb": "At Bull Mountain in Tigard, OR, our diverse floor plans cater to every lifestyle, from cozy one-bedroom nooks to spacious three-bedroom retreats. Curious about our community features? Visit our FAQs page for insightful answers that will help you envision your perfect home with us. Your ideal living space awaits!",
  "property_floorplans_blurb": "At Bull Mountain in Tigard, OR, diverse floor plans await your unique lifestyle. Choose from stylish one, two, and three-bedroom apartments designed for comfort and convenience. Each space offers modern amenities that elevate everyday living. Browse our available apartment homes today and envision your ideal retreat.",
  "property_gallery_blurb": "At Bull Mountain in Tigard, OR, your ideal living space awaits. Picture cozy evenings on your private balcony, invigorating workouts in the fitness center, and endless fun at the playground. With modern amenities like high-speed internet and stainless steel appliances, this community offers luxurious living tailored just for you!",
  "property_interactivemap_blurb": "Nestled in the heart of Tigard, OR, Bull Mountain offers an array of thoughtfully designed one, two, and three-bedroom apartments. Enjoy resort-style amenities like a sparkling pool, state-of-the-art fitness center, and lush outdoor spaces. Ready to find your next home? Navigate our interactive community map for pricing and availability!",
  "property_pets_blurb": "At Bull Mountain in Tigard, OR, your furry companions are more than welcome. With a spacious atmosphere designed for both relaxation and adventure, residents can enjoy the beauty of nature right outside their door. Treat your pets to the life they deserve—because home is also for them.",
  "property_referafriend_blurb": "At Bull Mountain in Tigard, OR, friendship flourishes in our vibrant community. With spacious one, two, and three-bedroom floor plans, your ideal home awaits. Great friends make great neighbors—refer a friend today and share the charm of Bull Mountain together! Experience the perfect blend of comfort and companionship.",
  "property_residentaccess_blurb": "At Bull Mountain in Tigard, OR, our thoughtfully designed one, two, and three-bedroom apartments cater to your every need. Enjoy seamless living—access your resident portal today for effortless rent payments, maintenance requests, and community updates. Experience convenience with just a few clicks! ",
  "property_reviews_blurb": "At Bull Mountain in Tigard, OR, residents rave about their vibrant community, stating it offers “the perfect blend of comfort and convenience.” Relish in spacious living, beautiful surroundings, and unparalleled amenities. Curious about life here? See what our residents have to say about living at our community!",
  "property_created_at": "1762201193384",
  "property_scheduletour_blurb": "At Bull Mountain in Tigard, OR, we offer an array of thoughtfully designed floor plans, from cozy one-bedrooms to spacious three-bedrooms. Experience the vibrant community and stunning surroundings. Curious about life here? Hear firsthand from our residents and schedule a tour today to envision your next home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Bull Mountain in Tigard, OR, our diverse floor plans—including one, two, and three-bedroom apartments—offer the perfect blend of comfort and style. We appreciate your interest and will connect with you soon to help you find your new home!",
  "property_virtualtours_blurb": "At Bull Mountain in Tigard, OR, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Wander through our vibrant community with a virtual tour and envision your future home surrounded by nature’s beauty. Experience the ideal lifestyle today!",
  "property_copyright": "2025 All Rights Reserved. Bull Mountain",
  "property_seo_title_home": "Apartments in Tigard, OR | Bull Mountain Heights | Home",
  "property_seo_description_home": "Discover 1, 2, and 3-bedroom apartments in Tigard, OR, at Bull Mountain Heights with modern amenities and a convenient location near Cook Park.",
  "property_seo_title_floorplans": "Floor Plans | Tigard, OR Apartments for Rent",
  "property_seo_description_floorplans": "Explore 1, 2, and 3-bedroom apartments in Tigard, OR at Bull Mountain Heights featuring fully equipped kitchens, washers and dryers, and private patios.",
  "property_seo_title_amenities": "Apartments Near Portland, OR | Amenities",
  "property_seo_description_amenities": "Elevate your lifestyle at Bull Mountain in Tigard, OR! Enjoy stunning amenities from a refreshing pool to scenic trails, perfect for relaxation and adventure.",
  "property_seo_title_gallery": "Apartments For Rent in Tigard, OR | Gallery",
  "property_seo_description_gallery": "Browse photos of our apartments in Tigard, OR, at Bull Mountain Heights. See spacious interiors, community amenities, and beautifully maintained outdoor spaces.",
  "property_seo_title_virtualtours": "Two-bedroom Apartments Near Portland, OR | Virtual Tour",
  "property_seo_description_virtualtours": "Take a virtual tour of Bull Mountain Heights in Tigard, OR, and explore spacious apartment homes, community amenities, and shared spaces online.",
  "property_seo_title_interactivemap": "One-bedroom Apartments in Tigard, OR | Interactive Leasing",
  "property_seo_description_interactivemap": "Lease your next apartment online with Bull Mountain Heights in Tigard, OR. Review availability, compare floor plans, and begin the leasing process today.",
  "property_seo_title_neighborhood": "Tigard, OR Rentals | Bull Mountain Heights | Neighborhood",
  "property_seo_description_neighborhood": "Live near Cook Park, Progress Ridge TownSquare, Tigard Promenade, dining, shopping, and recreation when you choose our apartments for rent in Tigard, OR.",
  "property_seo_title_contact": "Apartments With a Pool in Tigard, OR | Contact",
  "property_seo_description_contact": "Contact Bull Mountain Heights to learn more about available floor plans, community amenities, leasing information, and more.",
  "property_seo_title_faqs": "FAQs | Apartments in Tigard, OR",
  "property_seo_description_faqs": "Got questions about Bull Mountain in Tigard, OR? Dive into our FAQs for insights on floor plans, amenities, and everything you need to call us home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tigard, OR",
  "property_seo_description_reviews": "Join the Bull Mountain community in Tigard, OR! Read resident reviews and see why our spacious apartments and top-notch amenities make home feel extraordinary.",
  "property_seo_title_applynow": "Two-bedroom Apartments in Tigard, OR | Apply Now",
  "property_seo_description_applynow": "Apply online for an apartment at Bull Mountain Heights in Tigard, OR. Browse available 1, 2, and 3-bedroom floor plans and start your application today.",
  "property_seo_title_residentaccess": "Apartments Near Cook Park in Tigard, OR | Resident Access",
  "property_seo_description_residentaccess": "Access the resident portal for Bull Mountain Heights to manage payments, submit maintenance requests, and stay connected with your community.",
  "property_seo_title_referafriend": "Refer A Friend | Bull Mountain",
  "property_seo_description_referafriend": "Refer a friend to Bull Mountain in Tigard, OR! Great friends make great neighbors—share the love and enjoy a vibrant community together!",
  "property_seo_title_scheduletour": "Apartments with Garages in Tigard, OR | Tour",
  "property_seo_description_scheduletour": "Schedule a tour of Bull Mountain Heights and explore a convenient neighborhood, modern amenities, and spacious 1-, 2-, and 3-bedroom rentals in Tigard, OR.",
  "property_seo_title_privacy": "Privacy Policy | Bull Mountain",
  "property_seo_description_privacy": "At Bull Mountain in Tigard, OR, your privacy matters. Dive into our policy to learn how we protect your information while you enjoy our vibrant community!",
  "property_seo_title_accessibility": "Website Accessibility | Bull Mountain",
  "property_seo_description_accessibility": "At Bull Mountain in Tigard, OR, we prioritize digital inclusion. Experience seamless access to our community—your comfort is our commitment.",
  "property_seo_title_sitemap": "Sitemap | Bull Mountain",
  "property_seo_description_sitemap": "Navigating your new home is easy at Bull Mountain! Check out our sitemap for a quick overview of our vibrant Tigard community and its amenities.",
  "property_seo_title_thankyou": "Rentals Near Portland, OR | Bull Mountain Heights | Thanks",
  "property_seo_description_thankyou": "Thank you for contacting Bull Mountain Heights Apartments. Our leasing team will be in touch soon with information about our apartment community.",
  "property_seo_title_pets": "Pet-friendly Apartments Near Portland, OR | Pets",
  "property_seo_description_pets": "Learn about the pet policy at Bull Mountain Heights and explore our pet-friendly apartments in Tigard, OR, with an on-site pet park.",
  "property_updated_at": "1791293659369",
  "amenities": [
    {
      "id": "custom_ea869b22-f4dd-4a8a-9539-a37523c97194",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39f3bf1b-3e64-4a31-803f-12ed939186fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1bba7a8f-3e3c-4a99-bdce-f020c2263f0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8587795f-b650-4bf8-a15e-0a2d0822e429",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Hot Tub",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa7c1f62-b0bc-4ff3-ac98-264539862288",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b4eda04-e52f-4daf-ad19-8a015f81f6ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "TV Lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_87282095-e069-4880-8a47-8a967c7970df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5b91dfb-e3cf-42de-9e09-99fb7b9820e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1b7630f-f9aa-4ec5-b1db-7f43e6c407ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e310836c-40f9-4f38-b6d5-6a0f2792df9d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8af2e2b-2eaf-422c-acf6-b33834248881",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b0fb564-2a89-4e7d-bcbb-28d9078d79d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c58e81e-cc0c-4258-9e5b-0a1428f1a037",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_60229939-c91e-4d6c-be95-b11a0f0b956f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a446afcb-80dc-411f-a559-399316f9a596",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Skylight*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00589b82-9c47-4d42-8b30-0379720141cf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Plank Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66876e2d-9adc-4b04-b556-1194168f2644",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Kitchens",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e06d5b1e-1f56-4440-8c94-dbad4e333194",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eeb1a816-d455-4bfe-99d4-b17dd37c851a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36df9c2b-036e-4b17-951e-ab9b5b208130",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Full Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7abb5093-738d-4b61-aa61-a9a9d779c26c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39492e79-dd87-4375-8ceb-f9c48f4b30da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Coffee Machine",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8d161070-8826-4e9f-b5ee-067a25cae1cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-987f-730c-844b-db115289915b.webp",
      "image_media": {
        "alt_text": "Bull Mountain Heights property signage with address 11430 SW Bull Mountain Rd.",
        "public_id": "019f3882-987f-730c-844b-db115289915b",
        "storage_key": "property/6767906449166802/019f3882-987f-730c-844b-db115289915b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Bull Mountain Heights, located at 11430 SW Bull Mountain Rd. Experience a vibrant community atmosphere.",
      "link": "",
      "alt_text": "Bull Mountain Heights property signage with address 11430 SW Bull Mountain Rd.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c420331a-a5f5-463a-8eba-04c8dd35b641",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-d154-70ca-94dc-2379c0f91d2d.webp",
      "image_media": {
        "alt_text": "Aerial view of an inviting swimming pool with lounge chairs and umbrellas.",
        "public_id": "019f3882-d154-70ca-94dc-2379c0f91d2d",
        "storage_key": "property/6767906449166802/019f3882-d154-70ca-94dc-2379c0f91d2d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and umbrellas for shade. Enjoy the sunshine and unwind in style.",
      "link": "",
      "alt_text": "Aerial view of an inviting swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_82534707-c078-4d62-b7cc-fb05b99a8b9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-59c8-7208-84fa-6dabc0284d07.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019f3883-59c8-7208-84fa-6dabc0284d07",
        "storage_key": "property/6767906449166802/019f3883-59c8-7208-84fa-6dabc0284d07.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the sparkling outdoor pool, surrounded by lush greenery and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27b6f9bb-8ab7-4140-bcd7-d6ff68062d5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-9369-7333-b69a-b74f778cc232.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with a grill and dining table under a wooden pergola.",
        "public_id": "019f3882-9369-7333-b69a-b74f778cc232",
        "storage_key": "property/6767906449166802/019f3882-9369-7333-b69a-b74f778cc232.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and grilling in this beautifully appointed outdoor kitchen, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Outdoor kitchen with a grill and dining table under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_85287de4-270d-46d1-b4aa-f1def3bd69fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-6d86-76cd-a125-9a69a102b3fc.webp",
      "image_media": {
        "alt_text": "Playground and outdoor grilling area with covered seating.",
        "public_id": "019f3883-6d86-76cd-a125-9a69a102b3fc",
        "storage_key": "property/6767906449166802/019f3883-6d86-76cd-a125-9a69a102b3fc.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the playground and gather with friends and family at the covered grilling station.",
      "link": "",
      "alt_text": "Playground and outdoor grilling area with covered seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7fa525d3-7c0d-4330-9f94-910cb84c1a8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-3e4d-75bf-9032-bef0db05af77.webp",
      "image_media": {
        "alt_text": "Outdoor amenities including a playground, grilling area, and swimming pool.",
        "public_id": "019f3883-3e4d-75bf-9032-bef0db05af77",
        "storage_key": "property/6767906449166802/019f3883-3e4d-75bf-9032-bef0db05af77.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our community amenities, featuring a playground for kids, a grilling station for outdoor cooking, and a refreshing swimming pool.",
      "link": "",
      "alt_text": "Outdoor amenities including a playground, grilling area, and swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4925142-c537-41e7-bf9f-0b4cedf28eca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-d9e7-703a-8d20-92c96147245c.webp",
      "image_media": {
        "alt_text": "Outdoor patio with grill, dining table, and seating area, next to a playground.",
        "public_id": "019f3882-d9e7-703a-8d20-92c96147245c",
        "storage_key": "property/6767906449166802/019f3882-d9e7-703a-8d20-92c96147245c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a community grill, dining space, and a playground for families.",
      "link": "",
      "alt_text": "Outdoor patio with grill, dining table, and seating area, next to a playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea229888-c189-4899-8f9e-4032ce21a4d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-99b3-7348-aff5-62a3a0791413.webp",
      "image_media": {
        "alt_text": "Dog park with benches, waste station, and fencing.",
        "public_id": "019f3882-99b3-7348-aff5-62a3a0791413",
        "storage_key": "property/6767906449166802/019f3882-99b3-7348-aff5-62a3a0791413.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "A dedicated dog park area with seating and waste disposal for residents and their pets.",
      "link": "",
      "alt_text": "Dog park with benches, waste station, and fencing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31c2b238-8aed-4552-bb2a-302c2f58f3c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-fa78-70f0-9190-067ec04c3ae8.webp",
      "image_media": {
        "alt_text": "An aerial view of a fenced dog park with a tunnel and an agility hoop.",
        "public_id": "019f3882-fa78-70f0-9190-067ec04c3ae8",
        "storage_key": "property/6767906449166802/019f3882-fa78-70f0-9190-067ec04c3ae8.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Let your furry friends run and play in our dedicated dog park, featuring fun agility equipment and plenty of space to roam.",
      "link": "",
      "alt_text": "An aerial view of a fenced dog park with a tunnel and an agility hoop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9983de5a-7ed9-49a9-b12b-494610130ff5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-9938-7289-9734-a07ff6fa1f6c.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a fenced dog park featuring a blue bench and agility equipment.",
        "public_id": "019f3882-9938-7289-9734-a07ff6fa1f6c",
        "storage_key": "property/6767906449166802/019f3882-9938-7289-9734-a07ff6fa1f6c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the convenience of our on-site dog park, complete with agility equipment and seating, perfect for your furry friends.",
      "link": "",
      "alt_text": "Apartment building exterior with a fenced dog park featuring a blue bench and agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73cefc5c-cadd-41bf-a880-7fc5f6c14032",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-df94-752a-8fd8-6ddd43f86ac9.webp",
      "image_media": {
        "alt_text": "Playground with slides, climbing structures, and swings.",
        "public_id": "019f3882-df94-752a-8fd8-6ddd43f86ac9",
        "storage_key": "property/6767906449166802/019f3882-df94-752a-8fd8-6ddd43f86ac9.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures perfect for children.",
      "link": "",
      "alt_text": "Playground with slides, climbing structures, and swings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29d33015-ac2c-408b-9675-31c4731b6b59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-81b9-7670-a9ca-8304b5af7c6a.webp",
      "image_media": {
        "alt_text": "Bull Mountain Heights community monument sign with mountain and lake scenic mural.",
        "public_id": "019f3883-81b9-7670-a9ca-8304b5af7c6a",
        "storage_key": "property/6767906449166802/019f3883-81b9-7670-a9ca-8304b5af7c6a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy the scenic beauty of Bull Mountain Heights with this striking monument sign featuring a picturesque mountain and lake mural.",
      "link": "",
      "alt_text": "Bull Mountain Heights community monument sign with mountain and lake scenic mural.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0b3d7f7-b2d9-475f-8398-bc3ecfe13099",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-193a-764a-b8b1-77ff6a61f865.webp",
      "image_media": {
        "alt_text": "Apartment complex office building at dusk with playground nearby.",
        "public_id": "019f3883-193a-764a-b8b1-77ff6a61f865",
        "storage_key": "property/6767906449166802/019f3883-193a-764a-b8b1-77ff6a61f865.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Welcome to our community's office, a central hub for residents. Enjoy the convenience of our on-site playground for family fun.",
      "link": "",
      "alt_text": "Apartment complex office building at dusk with playground nearby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5614a279-97d9-4e80-abf6-a40cb1dc4f6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-d282-7562-8e11-5fb06fc48361.webp",
      "image_media": {
        "alt_text": "Property office building with signage and playground in background",
        "public_id": "019f3882-d282-7562-8e11-5fb06fc48361",
        "storage_key": "property/6767906449166802/019f3882-d282-7562-8e11-5fb06fc48361.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Visit our leasing office for tours and information. Enjoy the on-site playground for family fun.",
      "link": "",
      "alt_text": "Property office building with signage and playground in background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8fe03a9-be22-4f6e-8a77-c1aabe41e129",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-2c57-7286-a50d-11f5e7e36dab.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with modern furniture, potted plants, and wood-paneled ceiling.",
        "public_id": "019f3883-2c57-7286-a50d-11f5e7e36dab",
        "storage_key": "property/6767906449166802/019f3883-2c57-7286-a50d-11f5e7e36dab.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor seating area, featuring comfortable modern furniture and lush greenery.",
      "link": "",
      "alt_text": "Covered outdoor seating area with modern furniture, potted plants, and wood-paneled ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b68f9a9c-dc54-4d84-95c7-45d8c52dae4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-6a94-75ee-87d9-a61d9877935f.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, stationary bike, and vending machine.",
        "public_id": "019f3883-6a94-75ee-87d9-a61d9877935f",
        "storage_key": "property/6767906449166802/019f3883-6a94-75ee-87d9-a61d9877935f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and a convenient vending machine for post-workout snacks.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, stationary bike, and vending machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f18f09b2-8cc0-41f6-a9d4-a7afcb0fb4f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-b4d1-726f-8752-4331f855aaa8.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight racks, and a vending machine.",
        "public_id": "019f3882-b4d1-726f-8752-4331f855aaa8",
        "storage_key": "property/6767906449166802/019f3882-b4d1-726f-8752-4331f855aaa8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring state-of-the-art cardio machines, free weights, and convenient vending options.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight racks, and a vending machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c1ed6ee-a1b0-4980-90b2-676ced8d703f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-42c0-7191-a33c-da25dd637e53.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, free weights, yoga balls, and treadmills.",
        "public_id": "019f3883-42c0-7191-a33c-da25dd637e53",
        "storage_key": "property/6767906449166802/019f3883-42c0-7191-a33c-da25dd637e53.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art weight machines, free weights, cardio equipment, and space for stretching and yoga.",
      "link": "",
      "alt_text": "Fitness center with weight machines, free weights, yoga balls, and treadmills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc4b35ee-c3b8-4d7b-aed2-4b9fe48c5454",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-0410-76bb-985a-104ca9900195.webp",
      "image_media": {
        "alt_text": "Community lounge area with seating, coffee table, and exit to the outdoors.",
        "public_id": "019f3883-0410-76bb-985a-104ca9900195",
        "storage_key": "property/6767906449166802/019f3883-0410-76bb-985a-104ca9900195.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring comfortable seating, a unique coffee table, and direct access to outdoor spaces.",
      "link": "",
      "alt_text": "Community lounge area with seating, coffee table, and exit to the outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af94ee3c-2565-4c38-85fd-6e997fbf8d44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-db39-7290-b1fd-645ae8976599.webp",
      "image_media": {
        "alt_text": "Community coffee and refreshment station with coffee maker, microwave, sink, and seating area.",
        "public_id": "019f3882-db39-7290-b1fd-645ae8976599",
        "storage_key": "property/6767906449166802/019f3882-db39-7290-b1fd-645ae8976599.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our convenient community station, perfect for a quick pick-me-up.",
      "link": "",
      "alt_text": "Community coffee and refreshment station with coffee maker, microwave, sink, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_16029871-e063-41c1-b5af-5ce32d999cd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-ce32-709c-97d3-d65782b4aa41.webp",
      "image_media": {
        "alt_text": "Spacious living room with a blue sectional sofa, two dark blue accent chairs, a fireplace, and a dining area.",
        "public_id": "019f3882-ce32-709c-97d3-d65782b4aa41",
        "storage_key": "property/6767906449166802/019f3882-ce32-709c-97d3-d65782b4aa41.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in this beautifully appointed living area, featuring a cozy fireplace, comfortable seating, and ample space for dining and entertainment.",
      "link": "",
      "alt_text": "Spacious living room with a blue sectional sofa, two dark blue accent chairs, a fireplace, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_59f1d04d-3afa-475a-89d1-dc1f34e1ed43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-cfb2-72ce-98ab-60f3d1a8a0d4.webp",
      "image_media": {
        "alt_text": "Cozy lounge area with fireplace, seating, and view of pool and outdoor area.",
        "public_id": "019f3882-cfb2-72ce-98ab-60f3d1a8a0d4",
        "storage_key": "property/6767906449166802/019f3882-cfb2-72ce-98ab-60f3d1a8a0d4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lounge, featuring a warm fireplace, comfortable seating, and a scenic view of the community pool and outdoor spaces.",
      "link": "",
      "alt_text": "Cozy lounge area with fireplace, seating, and view of pool and outdoor area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d8c008c-88e2-4bd0-90e1-a96ed0cf2a50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-f89f-7038-8ae4-11a96ac20861.webp",
      "image_media": {
        "alt_text": "Aerial view of a rectangular swimming pool, hot tub, and clubhouse with lounge chairs and umbrellas.",
        "public_id": "019f3882-f89f-7038-8ae4-11a96ac20861",
        "storage_key": "property/6767906449166802/019f3882-f89f-7038-8ae4-11a96ac20861.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind at our sparkling outdoor swimming pool and hot tub, surrounded by comfortable lounge seating and umbrellas. Enjoy a refreshing dip or soak up the sun at our community's luxurious amenity.",
      "link": "",
      "alt_text": "Aerial view of a rectangular swimming pool, hot tub, and clubhouse with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4f2a448-b890-42f4-9a2c-ed57d291f14f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-2f9c-75b8-bc8d-5ffc91c9bd67.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019f3883-2f9c-75b8-bc8d-5ffc91c9bd67",
        "storage_key": "property/6767906449166802/019f3883-2f9c-75b8-bc8d-5ffc91c9bd67.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1a35fb8-70d7-49fc-8942-d0b0ab02c96a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-98eb-744b-9354-ba78171c2873.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies under a blue sky with clouds.",
        "public_id": "019f3882-98eb-744b-9354-ba78171c2873",
        "storage_key": "property/6767906449166802/019f3882-98eb-744b-9354-ba78171c2873.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Modern apartment buildings feature private balconies and well-maintained grounds, offering a comfortable living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_befbf532-18c4-40dd-8864-c639d991660b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-39aa-7396-8690-5596b1dda533.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and balconies, surrounded by trees.",
        "public_id": "019f3883-39aa-7396-8690-5596b1dda533",
        "storage_key": "property/6767906449166802/019f3883-39aa-7396-8690-5596b1dda533.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings, featuring attached garages and private balconies, nestled within a lush, green environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and balconies, surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_16c8f207-7034-45b9-ac20-c930e7cc7126",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-4246-767d-805b-e2b734421cdc.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex amenities including a pool, playground, and outdoor seating area.",
        "public_id": "019f3883-4246-767d-805b-e2b734421cdc",
        "storage_key": "property/6767906449166802/019f3883-4246-767d-805b-e2b734421cdc.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover resort-style living with our sparkling pool, fun-filled playground, and inviting outdoor lounge areas, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of apartment complex amenities including a pool, playground, and outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b62524b2-156a-43da-b4cc-57eb13736424",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-3b17-773f-b4e4-b96e53e8cb6b.webp",
      "image_media": {
        "alt_text": "Exterior view of a tan apartment building with multiple balconies and large trees.",
        "public_id": "019f3883-3b17-773f-b4e4-b96e53e8cb6b",
        "storage_key": "property/6767906449166802/019f3883-3b17-773f-b4e4-b96e53e8cb6b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of a tan apartment building with multiple balconies, surrounded by lush green trees and a bright blue sky. Offers a glimpse of the property's architecture and natural setting.",
      "link": "",
      "alt_text": "Exterior view of a tan apartment building with multiple balconies and large trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c44180f1-2398-4209-b992-22a6b8a9d7b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-b6b1-75bb-9ad2-0ca4c4d26e82.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush trees and landscaping.",
        "public_id": "019f3882-b6b1-75bb-9ad2-0ca4c4d26e82",
        "storage_key": "property/6767906449166802/019f3882-b6b1-75bb-9ad2-0ca4c4d26e82.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view of apartment buildings nestled among mature trees, showcasing the property's serene and natural setting.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with lush trees and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2894c4bf-07b4-46d7-b433-e569ee9587c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-8f35-7410-9d7f-c04847e4d2d8.webp",
      "image_media": {
        "alt_text": "Clubhouse and amenities building with pool in the background.",
        "public_id": "019f3882-8f35-7410-9d7f-c04847e4d2d8",
        "storage_key": "property/6767906449166802/019f3882-8f35-7410-9d7f-c04847e4d2d8.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to the clubhouse and amenities building, featuring a refreshing swimming pool and lush landscaping for relaxation and recreation.",
      "link": "",
      "alt_text": "Clubhouse and amenities building with pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cd24963e-f845-41da-af90-2310b4bd9615",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-320f-713f-8c34-d83d111a930a.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with multiple buildings, a swimming pool, a playground, and mature trees.",
        "public_id": "019f3883-320f-713f-8c34-d83d111a930a",
        "storage_key": "property/6767906449166802/019f3883-320f-713f-8c34-d83d111a930a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover a beautiful multifamily community featuring a refreshing swimming pool, a fun playground, and lush landscaping.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with multiple buildings, a swimming pool, a playground, and mature trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2d3727f-8ed9-45c6-a84b-f1c6d913f586",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-7f5e-7545-a671-19cebc75d7c9.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding landscape.",
        "public_id": "019f3883-7f5e-7545-a671-19cebc75d7c9",
        "storage_key": "property/6767906449166802/019f3883-7f5e-7545-a671-19cebc75d7c9.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the apartment community nestled among lush trees, with a highway and distant hills in the background.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_abaeee63-99eb-4653-bd3f-506e27dfb873",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-cfc4-7095-844e-a75c7150c231.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings nestled among trees with a highway in the background.",
        "public_id": "019f3882-cfc4-7095-844e-a75c7150c231",
        "storage_key": "property/6767906449166802/019f3882-cfc4-7095-844e-a75c7150c231.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover serene living nestled amongst lush trees. This aerial view showcases the apartment community's architecture and its proximity to the highway, offering convenience and natural beauty.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings nestled among trees with a highway in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b32af202-5609-4b19-bfa1-faba38d30bfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-670f-743a-b2d4-336c9ae30f7d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by lush trees and a highway.",
        "public_id": "019f3883-670f-743a-b2d4-336c9ae30f7d",
        "storage_key": "property/6767906449166802/019f3883-670f-743a-b2d4-336c9ae30f7d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this beautiful apartment community, nestled amidst abundant greenery with convenient access to nearby highways.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounded by lush trees and a highway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1ee0e0c-29b8-4438-889d-70d5ad26e119",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-6ef0-77d8-974b-88841ff474f2.webp",
      "image_media": {
        "alt_text": "Kitchen with modern cabinets, black stove, and stainless steel refrigerator.",
        "public_id": "019f3883-6ef0-77d8-974b-88841ff474f2",
        "storage_key": "property/6767906449166802/019f3883-6ef0-77d8-974b-88841ff474f2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Explore this well-appointed kitchen featuring contemporary cabinetry, a sleek black stove, and ample counter space for all your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with modern cabinets, black stove, and stainless steel refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de4b9e31-3504-4964-9e89-1be2b407ed33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-5b0b-73ae-b7d2-f6a5090d7da6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white countertops, and stainless steel appliances.",
        "public_id": "019f3883-5b0b-73ae-b7d2-f6a5090d7da6",
        "storage_key": "property/6767906449166802/019f3883-5b0b-73ae-b7d2-f6a5090d7da6.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and well-equipped kitchen featuring ample cabinet space, sleek countertops, and modern appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, white countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eadfbac9-1194-4d6c-957c-016fd48261a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-7e79-70ce-a8ad-c2df85bffed3.webp",
      "image_media": {
        "alt_text": "Modern galley kitchen with stainless steel appliances and ample cabinet space.",
        "public_id": "019f3883-7e79-70ce-a8ad-c2df85bffed3",
        "storage_key": "property/6767906449166802/019f3883-7e79-70ce-a8ad-c2df85bffed3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A sleek galley kitchen featuring stainless steel appliances, quartz countertops, and wood-look flooring, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern galley kitchen with stainless steel appliances and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_104e1d25-1e5a-48dd-9163-2508e4080af4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-b77b-733b-8a01-40ea2e7298a1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "019f3882-b77b-733b-8a01-40ea2e7298a1",
        "storage_key": "property/6767906449166802/019f3882-b77b-733b-8a01-40ea2e7298a1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and sleek countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1f5cfc8-c912-4cc7-b8db-0cc7f22dcc59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-d0d1-7022-a409-9c75e243adcf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood-look flooring.",
        "public_id": "019f3882-d0d1-7022-a409-9c75e243adcf",
        "storage_key": "property/6767906449166802/019f3882-d0d1-7022-a409-9c75e243adcf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring stainless steel appliances, ample cabinet space, and beautiful wood-look flooring. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d135a43-5b38-4597-9183-e5d0975765e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-62c7-73c9-a3f3-3b3a0ebb2a89.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets and quartz countertops.",
        "public_id": "019f3883-62c7-73c9-a3f3-3b3a0ebb2a89",
        "storage_key": "property/6767906449166802/019f3883-62c7-73c9-a3f3-3b3a0ebb2a89.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring ample cabinet storage, quartz countertops, and a stainless steel dishwasher. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba74768b-6bac-4363-baa9-d8ac961dd155",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-6d39-71dd-ac1e-a25b078c1b2c.webp",
      "image_media": {
        "alt_text": "Open-concept living area with kitchen pass-through.",
        "public_id": "019f3883-6d39-71dd-ac1e-a25b078c1b2c",
        "storage_key": "property/6767906449166802/019f3883-6d39-71dd-ac1e-a25b078c1b2c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen with stainless steel appliances and a breakfast bar, opening to a spacious living area with hardwood floors and a ceiling fan.",
      "link": "",
      "alt_text": "Open-concept living area with kitchen pass-through.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6763087c-4b41-4c87-bcdf-6ad31bf374fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-4259-725d-80a5-84e02092b625.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with blinds on the door and window.",
        "public_id": "019f3883-4259-725d-80a5-84e02092b625",
        "storage_key": "property/6767906449166802/019f3883-4259-725d-80a5-84e02092b625.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "The open-concept living space features a modern kitchen with wood cabinetry and a dining area with a ceiling fan and a view of the outdoors.",
      "link": "",
      "alt_text": "Kitchen and dining area with blinds on the door and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1e89305-6597-4ab3-8beb-bb2814707558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-3632-739a-bde5-47dc4e5c5465.webp",
      "image_media": {
        "alt_text": "Open concept living area with a kitchen and dining space.",
        "public_id": "019f3883-3632-739a-bde5-47dc4e5c5465",
        "storage_key": "property/6767906449166802/019f3883-3632-739a-bde5-47dc4e5c5465.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen and ample natural light.",
      "link": "",
      "alt_text": "Open concept living area with a kitchen and dining space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f7696e4-73a4-431e-a20f-a04cca2fea20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-69e3-7318-84ca-d2f231cfc61f.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and view of kitchen pass-through and windows",
        "public_id": "019f3883-69e3-7318-84ca-d2f231cfc61f",
        "storage_key": "property/6767906449166802/019f3883-69e3-7318-84ca-d2f231cfc61f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, vaulted ceilings, and a pass-through to the kitchen. Large windows offer abundant natural light.",
      "link": "",
      "alt_text": "Living room with fireplace and view of kitchen pass-through and windows",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f50ede8a-939f-4262-a9a7-d068de6112f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-5dbe-73ce-b9cb-f1e5a4a3c4f8.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and adjacent kitchen area.",
        "public_id": "019f3883-5dbe-73ce-b9cb-f1e5a4a3c4f8",
        "storage_key": "property/6767906449166802/019f3883-5dbe-73ce-b9cb-f1e5a4a3c4f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace and a view into the modern kitchen area, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with a fireplace and adjacent kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9943db45-ab0b-4375-a3bc-401d8b7fc037",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-2862-7655-99c3-b7a659c94356.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and open kitchen.",
        "public_id": "019f3883-2862-7655-99c3-b7a659c94356",
        "storage_key": "property/6767906449166802/019f3883-2862-7655-99c3-b7a659c94356.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace and an open kitchen layout with modern appliances.",
      "link": "",
      "alt_text": "Living room with a fireplace and open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_268e0f68-80f5-4b9e-8afb-1de688303196",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-8ecb-765d-90f0-047d336ff709.webp",
      "image_media": {
        "alt_text": "Spacious living room with vaulted ceiling, large windows, and fireplace.",
        "public_id": "019f3882-8ecb-765d-90f0-047d336ff709",
        "storage_key": "property/6767906449166802/019f3882-8ecb-765d-90f0-047d336ff709.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a vaulted ceiling, abundant natural light from large windows, and a cozy fireplace, flowing into the kitchen area.",
      "link": "",
      "alt_text": "Spacious living room with vaulted ceiling, large windows, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce6a97e8-de0e-4af4-b1a4-72c80098c752",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-95c0-7449-b296-9796e5445f36.webp",
      "image_media": {
        "alt_text": "Dining area with a ceiling fan, window with blinds, and wood-look flooring.",
        "public_id": "019f3882-95c0-7449-b296-9796e5445f36",
        "storage_key": "property/6767906449166802/019f3882-95c0-7449-b296-9796e5445f36.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright dining area with a ceiling fan and a large window, featuring elegant wood-look flooring and easy access to an outdoor space.",
      "link": "",
      "alt_text": "Dining area with a ceiling fan, window with blinds, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e879b018-153c-4269-8ee1-ea04819ebbed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-4255-77fe-bfb4-b4b00fee9b2e.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet, blinds on the window, and a closet.",
        "public_id": "019f3883-4255-77fe-bfb4-b4b00fee9b2e",
        "storage_key": "property/6767906449166802/019f3883-4255-77fe-bfb4-b4b00fee9b2e.webp",
        "width": 3072,
        "height": 2058
      },
      "title": "Apartment",
      "description": "Step into this cozy bedroom, featuring soft neutral carpeting and ample natural light from the window. Ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet, blinds on the window, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a78ecc20-f985-4212-b33e-5c3a94f1b8d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-4359-739b-911f-a04e61b8d3b6.webp",
      "image_media": {
        "alt_text": "Empty bedroom with sliding closet doors and a window.",
        "public_id": "019f3883-4359-739b-911f-a04e61b8d3b6",
        "storage_key": "property/6767906449166802/019f3883-4359-739b-911f-a04e61b8d3b6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and unfurnished bedroom with neutral walls, carpeted floors, and a sliding door closet. The window offers natural light.",
      "link": "",
      "alt_text": "Empty bedroom with sliding closet doors and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_97ce2ac5-f60c-408e-bf35-e355dfb36028",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-9358-73bf-a2d3-76d3fb0533c9.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and window",
        "public_id": "019f3882-9358-73bf-a2d3-76d3fb0533c9",
        "storage_key": "property/6767906449166802/019f3882-9358-73bf-a2d3-76d3fb0533c9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a sliding door closet and a large window with blinds overlooking trees.",
      "link": "",
      "alt_text": "Bedroom with closet and window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25292dab-6ee2-499c-a20e-6c965dc7ce0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-70d9-739a-8178-b46a83db7e93.webp",
      "image_media": {
        "alt_text": "Bedroom with a window and a closet",
        "public_id": "019f3883-70d9-739a-8178-b46a83db7e93",
        "storage_key": "property/6767906449166802/019f3883-70d9-739a-8178-b46a83db7e93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a large window with blinds, and a convenient walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a window and a closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8637d7a3-b201-414a-a52c-f024a3b69f5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-2b21-71dc-af9f-411e1c3ed661.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and window.",
        "public_id": "019f3883-2b21-71dc-af9f-411e1c3ed661",
        "storage_key": "property/6767906449166802/019f3883-2b21-71dc-af9f-411e1c3ed661.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a sliding door closet and a large window with blinds for natural light. Neutral carpeting and walls create a serene atmosphere.",
      "link": "",
      "alt_text": "Bedroom with closet and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c173967-cc67-4cf5-abd3-3ad2b483e03b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-57a8-70bf-b03e-4d03983548dd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with bathtub, toilet, and vanity with mirror.",
        "public_id": "019f3883-57a8-70bf-b03e-4d03983548dd",
        "storage_key": "property/6767906449166802/019f3883-57a8-70bf-b03e-4d03983548dd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a well-appointed bathroom featuring a bathtub, toilet, and vanity with ample counter space and storage.",
      "link": "",
      "alt_text": "Modern bathroom with bathtub, toilet, and vanity with mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5eb8c9c6-42ea-4302-82a7-00943280c58b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-d58c-71a9-9ec3-6f1f7f25773f.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub/shower combo",
        "public_id": "019f3882-d58c-71a9-9ec3-6f1f7f25773f",
        "storage_key": "property/6767906449166802/019f3882-d58c-71a9-9ec3-6f1f7f25773f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a vanity with a modern faucet, a toilet, and a bathtub/shower combination with a curved shower rod.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub/shower combo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c684daf-6ab2-41f8-9ce4-7a04e0b58b4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-7d93-732c-9965-8f4cfd9a7fbc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
        "public_id": "019f3883-7d93-732c-9965-8f4cfd9a7fbc",
        "storage_key": "property/6767906449166802/019f3883-7d93-732c-9965-8f4cfd9a7fbc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and comfort of this modern bathroom, featuring a spacious vanity, a clean toilet, and a relaxing bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e62e191c-f5d9-487e-b1f2-f20fb0e080b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-2e9a-7346-89d0-c3af1a1f02f1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
        "public_id": "019f3883-2e9a-7346-89d0-c3af1a1f02f1",
        "storage_key": "property/6767906449166802/019f3883-2e9a-7346-89d0-c3af1a1f02f1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Freshen up in this bright and modern bathroom, featuring a sleek vanity, toilet, and a pristine bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d099aad0-754a-4e1e-a175-e97c3fdfbaca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-4748-748f-8a4e-599cf364bf70.webp",
      "image_media": {
        "alt_text": "In-unit laundry with washer, dryer, and storage cabinets.",
        "public_id": "019f3883-4748-748f-8a4e-599cf364bf70",
        "storage_key": "property/6767906449166802/019f3883-4748-748f-8a4e-599cf364bf70.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities with a washer, dryer, and ample storage space, making chores a breeze.",
      "link": "",
      "alt_text": "In-unit laundry with washer, dryer, and storage cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_69bc2502-bd9e-43b9-aca4-c9c5c4a7d23b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-018f-718e-8528-0d4111b49283.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with overhead cabinets.",
        "public_id": "019f3883-018f-718e-8528-0d4111b49283",
        "storage_key": "property/6767906449166802/019f3883-018f-718e-8528-0d4111b49283.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complete with ample overhead storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with overhead cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_bab8cdfa-79a9-4c34-9b04-bf467682690b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "9309 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant offers a wide variety of vegetarian options, including the Avocado Eggrolls, Impossible Burger, and Pineapple Chicken and Shrimp. They also highlight the extensive menu with something for everyone, the delicious cheesecakes, and the friendly and attentive service.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-9a58-7799-95d3-a09ca551b0fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9a58-7799-95d3-a09ca551b0fb",
        "storage_key": "property/6767906449166802/019d02d1-9a58-7799-95d3-a09ca551b0fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/or/tigard-101.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275120421759837335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "45.450966",
      "poi_longitude": "-122.7823448",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-620-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8330-7713-8791-4d17779a5ef5",
        "storage_key": "property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6omzVcMlVQRl2T3w-HYt4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5123dcbd-8b66-4795-a746-f800c577be38",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Din Tai Fung",
      "poi_type": "Restaurants",
      "poi_address": "9724 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "Upscale eatery specializing in Taiwanese dumplings with soup, steamed dumplings, noodle dishes, fried rice and rice cakes.",
      "poi_long_description": "People say this Chinese restaurant serves delicious soup dumplings, fried rice, and wontons. They highlight the food is fresh, flavorful, and authentic, and the service is quick and efficient. They also like the lively atmosphere and the attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-9a58-7799-95d3-a4ef12ef460d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9a58-7799-95d3-a4ef12ef460d",
        "storage_key": "property/6767906449166802/019d02d1-9a58-7799-95d3-a4ef12ef460d.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://dtf.com/en/locations/tigard",
      "poi_directions_map_url": "https://maps.google.com/?cid=7925850032975282981&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung",
      "poi_latitude": "45.4486554",
      "poi_longitude": "-122.7813244",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-768-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8330-7713-8791-4d17779a5ef5",
        "storage_key": "property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJra5u8yENlVQRJYOCrpxG_m0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_14e01082-f879-492d-ae48-e130fc66ebd5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10657 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken nuggets with Chick-fil-A sauce and waffle fries. They highlight the food is fresh and the restaurant is clean and modern. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-9a91-7460-a91b-f64f9ccc66a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9a91-7460-a91b-f64f9ccc66a1",
        "storage_key": "property/6767906449166802/019d02d1-9a91-7460-a91b-f64f9ccc66a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/or/raleigh-hills?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16597217422825337868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "45.4869133",
      "poi_longitude": "-122.7862333",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-305-9158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8330-7713-8791-4d17779a5ef5",
        "storage_key": "property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9onNxANlVQRDLRta08pVeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_29edbe78-795b-4418-a380-1e2dd6fba704",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "BGs Food Cartel",
      "poi_type": "Restaurants",
      "poi_address": "4250 SW Rose Biggi Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Open-air space with over 30 international food trucks, plus an indoor/outdoor speakeasy-style bar.",
      "poi_long_description": "People say this restaurant offers a wide variety of tasty food options from numerous food trucks and carts. They highlight the spacious indoor and outdoor seating, the family-friendly atmosphere with a kids' play area, and the pet-friendly environment. They also like the clean facilities, ample parking, and the central bar with a good beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-9ad6-707f-ad2a-dbc7e965a30b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-9ad6-707f-ad2a-dbc7e965a30b",
        "storage_key": "property/6767906449166802/019d02d1-9ad6-707f-ad2a-dbc7e965a30b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bgfoodcartel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13359900484536572783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bgs-food-cartel",
      "poi_latitude": "45.4892645",
      "poi_longitude": "-122.8081145",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-605-9163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8330-7713-8791-4d17779a5ef5",
        "storage_key": "property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSQIYZ8OlVQRbxtf97TmZ7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6451e0a1-d351-4544-9e80-cafd7c94c4fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Oswego Grill - Lake Oswego",
      "poi_type": "Restaurants",
      "poi_address": "7 Centerpointe Dr, Lake Oswego, OR 97035, USA",
      "poi_short_description": "Wood-grilled steakhouse favorites served in a casual, romantic restaurant with daily happy hours.",
      "poi_long_description": "People say this restaurant serves delicious prime rib, salmon, and steak bites, and offers a variety of other menu options, including burgers, ribs, and pasta. They highlight the generous portions, reasonable prices, and cozy, intimate atmosphere. They also like the friendly and attentive service, and the management's presence in ensuring customer satisfaction.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-3c16-77c2-957b-cca0968e97d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-3c16-77c2-957b-cca0968e97d2",
        "storage_key": "property/6767906449166802/019d02d1-3c16-77c2-957b-cca0968e97d2.webp",
        "width": 749,
        "height": 679
      },
      "poi_business_url": "http://www.oswegogrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2739873119003492741&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oswego-grill---lake-oswego",
      "poi_latitude": "45.4202156",
      "poi_longitude": "-122.7403488",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-352-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8330-7713-8791-4d17779a5ef5",
        "storage_key": "property/6767906449166802/019d02d1-8330-7713-8791-4d17779a5ef5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVF5oS1zlVQRhUHY0xX8BSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_19d6271a-fc2a-446c-994f-21f7fd3094b7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Washington Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9585 SW Washington Square Rd, Portland, OR 97223, USA",
      "poi_short_description": "Large shopping center with a variety of department stores, specialty shops & food options.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including high-end brands and budget-friendly options, as well as a diverse food court and sit-down restaurants. They also highlight the clean and well-maintained environment, the spacious layout, and the ample parking.\n\nOther reviews mention the layout can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-3c16-77c2-957b-ca72d0021ed3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-3c16-77c2-957b-ca72d0021ed3",
        "storage_key": "property/6767906449166802/019d02d1-3c16-77c2-957b-ca72d0021ed3.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.shopwashingtonsquare.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8036230870585529003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-square",
      "poi_latitude": "45.4502491",
      "poi_longitude": "-122.7812183",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-639-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-832d-73ca-a94c-09573f3ed6de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-832d-73ca-a94c-09573f3ed6de",
        "storage_key": "property/6767906449166802/019d02d1-832d-73ca-a94c-09573f3ed6de.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy9M2zVcMlVQRq1JHJmZthm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fed8634e-98dc-46d4-814a-1add7d4fa588",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Uwajimaya Beaverton",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of Japanese, Hawaiian, and other Asian foods, including fresh seafood, poke, musubi, onigiri, and bento boxes, as well as a bakery, bookstore, and deli. They highlight the reasonable prices and the fun, unique shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-3cb5-73bc-8619-3bb08f55d3ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-3cb5-73bc-8619-3bb08f55d3ef",
        "storage_key": "property/6767906449166802/019d02d1-3cb5-73bc-8619-3bb08f55d3ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/beaverton/?utm_source=localprofiles&utm_medium=organic&utm_content=beaverton&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570527899701517362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-beaverton",
      "poi_latitude": "45.48564529999999",
      "poi_longitude": "-122.7849074",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-643-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8332-7735-9e3f-5d5f8f0dcec7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8332-7735-9e3f-5d5f8f0dcec7",
        "storage_key": "property/6767906449166802/019d02d1-8332-7735-9e3f-5d5f8f0dcec7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVB9wAQMlVQRMpyACFA0L1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_9bae61a1-738c-45bc-b360-a55404e46a41",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Bridgeport Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "7455 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_long_description": "Visitors say this shopping center offers a wide variety of stores, restaurants, and a movie theater, with outdoor seating, fire pits, and a playground. They also highlight the clean and modern facilities, the convenient location, and the family-friendly atmosphere.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-3cb3-7094-afc8-58678a04cd5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-3cb3-7094-afc8-58678a04cd5a",
        "storage_key": "property/6767906449166802/019d02d1-3cb3-7094-afc8-58678a04cd5a.webp",
        "width": 1280,
        "height": 484
      },
      "poi_business_url": "https://www.bridgeport-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515733834919836986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bridgeport-village",
      "poi_latitude": "45.3957237",
      "poi_longitude": "-122.7528244",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-968-1704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-832d-73ca-a94c-09573f3ed6de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-832d-73ca-a94c-09573f3ed6de",
        "storage_key": "property/6767906449166802/019d02d1-832d-73ca-a94c-09573f3ed6de.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnYnrbetylVQROv3TC5iu6SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_628f9e11-148d-40a4-944d-7bc91e5db76a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3025 SW Cedar Hills Blvd, Beaverton, OR 97005, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Shoppers say this supermarket offers great prices on groceries, especially bulk items, and has a wide selection of products. They also highlight the friendly and helpful staff, and appreciate the affordable prices and convenient 24-hour access.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-421f-72bc-b177-b3f160764a60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-421f-72bc-b177-b3f160764a60",
        "storage_key": "property/6767906449166802/019d02d1-421f-72bc-b177-b3f160764a60.webp",
        "width": 1280,
        "height": 744
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15287079724831147658&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "45.49809399999999",
      "poi_longitude": "-122.810114",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-644-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8332-7735-9e3f-5d5f8f0dcec7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8332-7735-9e3f-5d5f8f0dcec7",
        "storage_key": "property/6767906449166802/019d02d1-8332-7735-9e3f-5d5f8f0dcec7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk19IebsOlVQRigaj6wOeJtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_ee14c1c7-2cac-415c-b97e-f7e164bac302",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "H Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "13600 SW Pacific Hwy, Tigard, OR 97223, USA",
      "poi_short_description": "Grocery store chain with a large selection of Asian items, including fresh produce, seafood, and banchan.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, seafood, meats, and Asian products, including kimchi, snacks, and baked goods. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-4231-742b-9ec1-22da9cbb3891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-4231-742b-9ec1-22da9cbb3891",
        "storage_key": "property/6767906449166802/019d02d1-4231-742b-9ec1-22da9cbb3891.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://www.hmartus.com/tigard",
      "poi_directions_map_url": "https://maps.google.com/?cid=1049668536271746817&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart",
      "poi_latitude": "45.420862",
      "poi_longitude": "-122.782354",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-620-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8332-7735-9e3f-5d5f8f0dcec7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8332-7735-9e3f-5d5f8f0dcec7",
        "storage_key": "property/6767906449166802/019d02d1-8332-7735-9e3f-5d5f8f0dcec7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9G6KToNlVQRAbdh7PgrkQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_225f0592-ef51-4d2e-8eac-35645393d3b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Portland Community College Sylvania",
      "poi_type": "Education",
      "poi_address": "12000 SW 49th Ave, Portland, OR 97219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-a46c-750e-967a-0eca5dd78a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a46c-750e-967a-0eca5dd78a2a",
        "storage_key": "property/6767906449166802/019d02d1-a46c-750e-967a-0eca5dd78a2a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pcc.edu/about/locations/sylvania/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6662908794779881992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-community-college-sylvania",
      "poi_latitude": "45.4375445",
      "poi_longitude": "-122.7302887",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 971-722-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-832c-74d8-81d9-4ef966886c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-832c-74d8-81d9-4ef966886c92",
        "storage_key": "property/6767906449166802/019d02d1-832c-74d8-81d9-4ef966886c92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUfp1OLoMlVQRCFKuSz9od1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dad5a9ba-9f9b-472c-aad8-c00a408d6149",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Beaverton City Library",
      "poi_type": "Education",
      "poi_address": "12375 SW 5th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Multistory library with kids' areas, computers and board game rentals.",
      "poi_long_description": "People say this library offers a wide variety of books, audio, video, and streaming services, as well as a \"Library of Things\" with items like bread makers and air fryers. They highlight the beautiful architecture, peaceful atmosphere, and ample seating with outlets, and appreciate the clean bathrooms and designated reading room. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-4408-77bc-892d-de9660ff596c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-4408-77bc-892d-de9660ff596c",
        "storage_key": "property/6767906449166802/019d02d1-4408-77bc-892d-de9660ff596c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://beavertonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2456838086164544331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-city-library",
      "poi_latitude": "45.4840984",
      "poi_longitude": "-122.804071",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-644-2197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-832c-74d8-81d9-4ef966886c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-832c-74d8-81d9-4ef966886c92",
        "storage_key": "property/6767906449166802/019d02d1-832c-74d8-81d9-4ef966886c92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_YnSyAMlVQRS_t89DhxGCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7768a234-a74a-4de3-a657-bd16a2a7f73b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "PCC Library: Sylvania Campus",
      "poi_type": "Education",
      "poi_address": "C7R8+4H, 12000 SW 49th Ave, Portland, OR 97219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-a6d3-708e-a75f-0a4441091e7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a6d3-708e-a75f-0a4441091e7c",
        "storage_key": "property/6767906449166802/019d02d1-a6d3-708e-a75f-0a4441091e7c.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.pcc.edu/library/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10862499362173307260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pcc-library-sylvania-campus",
      "poi_latitude": "45.4381342",
      "poi_longitude": "-122.7307846",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 971-722-4935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-c7d1-76b5-887c-8da34ab4c318.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-c7d1-76b5-887c-8da34ab4c318",
        "storage_key": "property/6767906449166802/019d02d1-c7d1-76b5-887c-8da34ab4c318.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbg3R7oMlVQRfEk_L55Zv5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_982260fc-58ca-4180-ad3f-8d139b61f285",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Fogelbo Historic Log Home",
      "poi_type": "Entertainment",
      "poi_address": "Portland, OR 97223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-a6d3-708e-a75f-0f6a2aa341b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a6d3-708e-a75f-0f6a2aa341b6",
        "storage_key": "property/6767906449166802/019d02d1-a6d3-708e-a75f-0f6a2aa341b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nordicnorthwest.org/fogelbo",
      "poi_directions_map_url": "https://maps.google.com/?cid=11192867665588144266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fogelbo-historic-log-home",
      "poi_latitude": "45.4566478",
      "poi_longitude": "-122.7666597",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-977-0275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3ptVvUMlVQRikhW6dYNVZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_259ef652-f212-49f8-9444-105354ed5616",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Oswego Heritage House",
      "poi_type": "Entertainment",
      "poi_address": "398 10th St, Lake Oswego, OR 97034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-48f4-7225-81ae-1ede6a0b179d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-48f4-7225-81ae-1ede6a0b179d",
        "storage_key": "property/6767906449166802/019d02d1-48f4-7225-81ae-1ede6a0b179d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.oswegoheritage.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6754602695372398718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oswego-heritage-house",
      "poi_latitude": "45.4206071",
      "poi_longitude": "-122.6761211",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-635-6373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f9-76da-b5ed-a59d727d2f0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f9-76da-b5ed-a59d727d2f0e",
        "storage_key": "property/6767906449166802/019d02d1-88f9-76da-b5ed-a59d727d2f0e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7KSI590lVQRfmCRMF0rvV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_774ca335-dbc7-4e2d-9bf3-09c3bccf23b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Vintage Tek",
      "poi_type": "Entertainment",
      "poi_address": "13489 SW Karl Braun Dr, Beaverton, OR 97077, USA",
      "poi_short_description": "Museum with free admission focusing on the technology history of the area's high tech industry.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-49d3-742b-88e7-695d07b32063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-49d3-742b-88e7-695d07b32063",
        "storage_key": "property/6767906449166802/019d02d1-49d3-742b-88e7-695d07b32063.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://vintagetek.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1408646836363968954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vintage-tek",
      "poi_latitude": "45.4988762",
      "poi_longitude": "-122.8155076",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 503-644-0161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f9-76da-b5ed-a59d727d2f0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f9-76da-b5ed-a59d727d2f0e",
        "storage_key": "property/6767906449166802/019d02d1-88f9-76da-b5ed-a59d727d2f0e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6SlUK7wOlVQRusFzl9WEjBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c929c4ea-422e-45db-b6fb-c896471c5a7c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Tualatin high stadium",
      "poi_type": "Entertainment",
      "poi_address": "22300 SW Boones Ferry Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-aa9c-70ba-830f-34974c1815b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-aa9c-70ba-830f-34974c1815b9",
        "storage_key": "property/6767906449166802/019d02d1-aa9c-70ba-830f-34974c1815b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ttsdschools.org/tuhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=8964509993261762683&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tualatin-high-stadium",
      "poi_latitude": "45.3590731",
      "poi_longitude": "-122.7700958",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-431-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f8-729a-85a1-964346738c6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f8-729a-85a1-964346738c6d",
        "storage_key": "property/6767906449166802/019d02d1-88f8-729a-85a1-964346738c6d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuZD6rE5tlVQRe4jOxVdWaHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2db0253d-1986-4774-9984-be2b904f5939",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Heritage Center-Sherwood",
      "poi_type": "Entertainment",
      "poi_address": "22552 SW Park St, Sherwood, OR 97140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-50be-7472-a30f-c729aaffa3be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-50be-7472-a30f-c729aaffa3be",
        "storage_key": "property/6767906449166802/019d02d1-50be-7472-a30f-c729aaffa3be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://sites.google.com/view/sherwood-historical-society/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=14128978490134038905&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heritage-center-sherwood",
      "poi_latitude": "45.35548989999999",
      "poi_longitude": "-122.8429071",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-625-1236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f9-76da-b5ed-a59d727d2f0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f9-76da-b5ed-a59d727d2f0e",
        "storage_key": "property/6767906449166802/019d02d1-88f9-76da-b5ed-a59d727d2f0e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZKtcfFslVQReQmTBxQ3FMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b42ef9be-fd22-4bfc-aeb7-55fa05cb8e50",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7405 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain, clean gym featuring free weights, sports facilities and friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of weights, cardio equipment, and classes, as well as a basketball court, hot tub, sauna, and pool. They also highlight the clean facilities, including the locker rooms and sauna, and the friendly and helpful staff.\n\nOther reviews mention the Wi-Fi can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-ae0d-71a7-bd65-0b38ff409093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-ae0d-71a7-bd65-0b38ff409093",
        "storage_key": "property/6767906449166802/019d02d1-ae0d-71a7-bd65-0b38ff409093.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1097&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650673231861924082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.385637",
      "poi_longitude": "-122.752729",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-404-0126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyqRr41ylVQR8kB0ia6lUcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9cef0d57-c6c8-4787-893b-e40728b2ff48",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7255 SW Dartmouth St, Tigard, OR 97223, USA",
      "poi_short_description": "Nationwide gym chain with an inclusive vibe offering massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a wide selection of weights, machines, and cardio equipment, as well as amenities like tanning, massage chairs, and red light therapy. They highlight the affordable membership options, the clean and spacious facility, and the welcoming, non-judgmental atmosphere. They also like the friendly, helpful, and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-adea-729b-8589-28fdf5d4a443.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-adea-729b-8589-28fdf5d4a443",
        "storage_key": "property/6767906449166802/019d02d1-adea-729b-8589-28fdf5d4a443.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tigard-tigard-triangle-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1183844742547254266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.43372249999999",
      "poi_longitude": "-122.7517173",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-746-6489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb1JzYwNlVQR-iu-ZIXcbRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c280793d-2c69-4f10-a558-c56427886fdc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Emergency Veterinary Clinic of Tualatin",
      "poi_type": "Health and Wellness",
      "poi_address": "8250 SW Tonka St, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-b260-76c3-bf9c-01066fd9a8a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b260-76c3-bf9c-01066fd9a8a1",
        "storage_key": "property/6767906449166802/019d02d1-b260-76c3-bf9c-01066fd9a8a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://evcot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13648983288718338961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emergency-veterinary-clinic-of-tualatin",
      "poi_latitude": "45.3804563",
      "poi_longitude": "-122.7613867",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-691-7922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYUHDYRylVQRkatMVfztar0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_2430fa99-ae01-43ae-99fe-e24445429854",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "OMEGA Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "9700 SW Harvest Ct STE 180, Beaverton, OR 97005, USA",
      "poi_short_description": "Gymnastics center offering recreational and competitive programs, plus classes for adults.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-57d9-739c-be22-559a7bcae9f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-57d9-739c-be22-559a7bcae9f5",
        "storage_key": "property/6767906449166802/019d02d1-57d9-739c-be22-559a7bcae9f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.omega-gymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4329032880408303612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "omega-gymnastics",
      "poi_latitude": "45.4786099",
      "poi_longitude": "-122.7763601",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-466-4872",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-832c-74d8-81d9-4ef966886c92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-832c-74d8-81d9-4ef966886c92",
        "storage_key": "property/6767906449166802/019d02d1-832c-74d8-81d9-4ef966886c92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKyngVkUMlVQR_Be58XfQEzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f35f1c5a-2dcd-422b-a5a6-022e1870efb1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11100 SW Murray Scholls Pl, Beaverton, OR 97007, USA",
      "poi_short_description": "Fitness center chain providing cardio and strength equipment, plus personal training.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.24hourfitness.com/gyms/beaverton-or/murray-scholls-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=15833735773317614282&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.4389581",
      "poi_longitude": "-122.8297395",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-579-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeFJoZ0NlVQRysr9i8u6vNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_db28f8a3-bd0e-4169-b991-49d0d83aea13",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Crunch Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8585 SW Cascade Ave, Beaverton, OR 97008, USA",
      "poi_short_description": "Spacious, clean gym (part of a national chain) catering to a diverse clientele, with equipment including free weights and classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes, and the staff is friendly and helpful.\n\nOther reviews mention the facilities can be poorly maintained and the cancellation process can be difficult.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.crunch.com/locations/beaverton",
      "poi_directions_map_url": "https://maps.google.com/?cid=6931298468353193180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness",
      "poi_latitude": "45.4575889",
      "poi_longitude": "-122.7866019",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-227-8624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVYoJlVQR3LRmvjvrMGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_53ea4291-1970-4c7e-ad1b-8fd346790db9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Legacy Meridian Park Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19300 SW 65th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/hospitals/legacy-meridian-park-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13283930296531003614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legacy-meridian-park-medical-center",
      "poi_latitude": "45.3784235",
      "poi_longitude": "-122.7407424",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-692-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-89a3-738f-8ebe-893b01c47fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-89a3-738f-8ebe-893b01c47fe3",
        "storage_key": "property/6767906449166802/019d02d1-89a3-738f-8ebe-893b01c47fe3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXGsTWBylVQR3qjHMTkAWrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4b719498-e1d5-4eb2-ab88-e7986a1eacc6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Virginia Garcia Beaverton Wellness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2725 SW Cedar Hills Blvd UNIT 200, Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://virginiagarcia.org/clinics-providers/beaverton-wellness-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4774016321365581691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "virginia-garcia-beaverton-wellness-center",
      "poi_latitude": "45.5005233",
      "poi_longitude": "-122.8090182",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-352-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-89a3-738f-8ebe-893b01c47fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-89a3-738f-8ebe-893b01c47fe3",
        "storage_key": "property/6767906449166802/019d02d1-89a3-738f-8ebe-893b01c47fe3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53srCbsOlVQRe5_p6oy2QEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ee41e72d-f691-40c9-b37c-a66ce06f03ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Cook Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17005 SW 92nd Ave, Tigard, OR 97224, USA",
      "poi_short_description": "Riverside park offering various sports & picnic areas, as well as a playground & a boat ramp.",
      "poi_long_description": "People say this city park offers a playground, picnic areas, sports fields, walking paths, and river access for kayaking and paddleboarding. They highlight the park's spaciousness, clean facilities, and family-friendly atmosphere. They also like the ample parking and covered pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-b806-770f-a55e-94541d15d9ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b806-770f-a55e-94541d15d9ea",
        "storage_key": "property/6767906449166802/019d02d1-b806-770f-a55e-94541d15d9ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tigard-or.gov/Home/Components/FacilityDirectory/FacilityDirectory/143/181",
      "poi_directions_map_url": "https://maps.google.com/?cid=17281400391354763777&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cook-family-park",
      "poi_latitude": "45.39603959999999",
      "poi_longitude": "-122.771663",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-718-2591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8f13-724c-8abd-281dfe01b5e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8f13-724c-8abd-281dfe01b5e5",
        "storage_key": "property/6767906449166802/019d02d1-8f13-724c-8abd-281dfe01b5e5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_XlT7xylVQRAUr_Wxje0-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1e2c2603-9c30-43d0-9e42-1c89cf90eb43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "RedTail Golf Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8200 SW Scholls Ferry Rd, Beaverton, OR 97008, USA",
      "poi_short_description": "Golf center at an 18-hole course offering practice facilities, lessons, a pro shop & an eatery.",
      "poi_long_description": "People say this golf course offers excellent club fittings and professional lessons with expert instructors. They also highlight the well-stocked pro shop, the ability to track shots using TrackMan, and the accommodating staff.\n\nOther reviews mention the course can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-65a5-752c-9187-1c6c59ce8de5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-65a5-752c-9187-1c6c59ce8de5",
        "storage_key": "property/6767906449166802/019d02d1-65a5-752c-9187-1c6c59ce8de5.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://golfredtail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15748737038652720950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redtail-golf-center",
      "poi_latitude": "45.4608887",
      "poi_longitude": "-122.778375",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-646-5166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-9016-73a6-8b2d-a13711b1c7bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-9016-73a6-8b2d-a13711b1c7bc",
        "storage_key": "property/6767906449166802/019d02d1-9016-73a6-8b2d-a13711b1c7bc.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTYBlhF4MlVQRNsfuceXAjto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7e4cbc0a-7e2e-43e3-a145-c4564d5a731a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Gabriel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SW 45th Ave & Vermont Street, Portland, OR 97219, USA",
      "poi_short_description": "91-acre space with amenities including skate park, off-leash dog area, tennis court & sports fields.",
      "poi_long_description": "People say this city park offers a wide variety of recreational activities, including tennis, pickleball, basketball, and a skate park, as well as walking trails, a playground, and a dog park. They highlight the park's versatility, with features suitable for all ages and abilities, and the well-maintained facilities, including restrooms and picnic tables. They also like the beautiful, forested setting and the ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-b954-774d-90ee-97489a64b9f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b954-774d-90ee-97489a64b9f1",
        "storage_key": "property/6767906449166802/019d02d1-b954-774d-90ee-97489a64b9f1.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.portlandoregon.gov/parks/finder/index.cfm?propertyid=136&action=ViewPark",
      "poi_directions_map_url": "https://maps.google.com/?cid=8816564431343279027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gabriel-park",
      "poi_latitude": "45.474297",
      "poi_longitude": "-122.7191089",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-823-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8f13-724c-8abd-281dfe01b5e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8f13-724c-8abd-281dfe01b5e5",
        "storage_key": "property/6767906449166802/019d02d1-8f13-724c-8abd-281dfe01b5e5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQb4pLp4LlVQRs1uPXaO6Wno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0c85337d-3428-4221-bddb-2a63914f6318",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Cooper Mountain Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18892 SW Kemmer Rd #5682, Beaverton, OR 97007, USA",
      "poi_short_description": "Scenic 230-acre park overlooking the river with multiple habitats, hiking trails & nature programs.",
      "poi_long_description": "People say this park offers beautiful trails with varying terrain, perfect for hiking and bird watching. They highlight the well-maintained gravel paths, scenic views, and opportunities to spot wildlife like deer, bunnies, and squirrels. They also like the peaceful and secluded atmosphere, suitable for families and people of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-6843-72df-b942-d7decf0b3825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-6843-72df-b942-d7decf0b3825",
        "storage_key": "property/6767906449166802/019d02d1-6843-72df-b942-d7decf0b3825.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/cooper-mountain-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=899869489749514377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cooper-mountain-nature-park",
      "poi_latitude": "45.4524826",
      "poi_longitude": "-122.8712162",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-629-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-8f13-724c-8abd-281dfe01b5e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-8f13-724c-8abd-281dfe01b5e5",
        "storage_key": "property/6767906449166802/019d02d1-8f13-724c-8abd-281dfe01b5e5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZxuDwwSlVQRiVi7gIj6fAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b76c2058-4f54-4219-a24a-a6903d21618c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Beaverton TC MAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-bbe0-720d-af24-744cb534bf3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-bbe0-720d-af24-744cb534bf3c",
        "storage_key": "property/6767906449166802/019d02d1-bbe0-720d-af24-744cb534bf3c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9821",
      "poi_directions_map_url": "https://maps.google.com/?cid=13913915888813031590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-tc-max-station",
      "poi_latitude": "45.4914575",
      "poi_longitude": "-122.8016546",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ7Mt6YOlVQRpkBdI8goGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_726cc0c0-29f7-464f-81ca-abf493c3971b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Millikan Way",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trimet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285898637418825828&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "millikan-way",
      "poi_latitude": "45.49523019999999",
      "poi_longitude": "-122.8216184",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0Zr7ZYOlVQRZAiW7B61QcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e9860be4-28f9-4587-b368-b2af074fe4b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Beaverton Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trimet.org/ride/m/stop.html?stop_id=9823",
      "poi_directions_map_url": "https://maps.google.com/?cid=10105843167513541039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-central",
      "poi_latitude": "45.49042590000001",
      "poi_longitude": "-122.8070926",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC6nm8qEOlVQRr_lzW9EqP4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_92c0e7f6-a885-4f11-9ad0-39abe959762f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Tigard TC WES Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tigard, OR 97223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13852866008831738875&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tigard-tc-wes-station",
      "poi_latitude": "45.430084",
      "poi_longitude": "-122.769663",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-9011-7561-b5fe-cf4175afa9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-9011-7561-b5fe-cf4175afa9f1",
        "storage_key": "property/6767906449166802/019d02d1-9011-7561-b5fe-cf4175afa9f1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRVBsSANlVQR-8N_ST1EP8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_d733846b-c0eb-47e5-870a-5e8c59933cc4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Hall/Nimbus WES Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-7566-751c-8996-d388278d1507.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-7566-751c-8996-d388278d1507",
        "storage_key": "property/6767906449166802/019d02d1-7566-751c-8996-d388278d1507.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://trimet.org/#tracker/stop/13067",
      "poi_directions_map_url": "https://maps.google.com/?cid=12175543590952059449&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hallnimbus-wes-station",
      "poi_latitude": "45.457639",
      "poi_longitude": "-122.7870388",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-9011-7561-b5fe-cf4175afa9f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-9011-7561-b5fe-cf4175afa9f1",
        "storage_key": "property/6767906449166802/019d02d1-9011-7561-b5fe-cf4175afa9f1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJXeaJjlAMlVQROUL7HWM4-Kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_96c4d145-d7f0-41a2-8c78-4edbd02a3a67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Lam Research",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11355 SW Leveton Dr, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-bef2-76cd-b028-620583c2033c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-bef2-76cd-b028-620583c2033c",
        "storage_key": "property/6767906449166802/019d02d1-bef2-76cd-b028-620583c2033c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lamresearch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8683645162624889977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lam-research",
      "poi_latitude": "45.38651220000001",
      "poi_longitude": "-122.7923427",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-685-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_cRBl5tlVQRebTLeUSBgng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_946d2368-d48d-411d-b64f-42f89283c417",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Nike - Elite",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3003 SW 153rd Dr, Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-7837-75bc-b42f-e630cdeac76a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-7837-75bc-b42f-e630cdeac76a",
        "storage_key": "property/6767906449166802/019d02d1-7837-75bc-b42f-e630cdeac76a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3333022774587773800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike---elite",
      "poi_latitude": "45.4985961",
      "poi_longitude": "-122.8350982",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAyzsL-0OlVQRaFOX641GQS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b97b8053-05b5-4b36-95d0-818409c2b502",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Lam Research - Building K",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lamresearch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15674694321931209481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lam-research---building-k",
      "poi_latitude": "45.3849983",
      "poi_longitude": "-122.7886581",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-685-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK70m8mBtlVQRCcuKDXCzh9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_31757d6f-c605-4906-bfad-92bc9c17fd16",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Nike - Tiempo",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3005 SW 154th Terrace, Beaverton, OR 97006, USA",
      "poi_short_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_long_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-7985-72ce-b39c-71b34a298856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-7985-72ce-b39c-71b34a298856",
        "storage_key": "property/6767906449166802/019d02d1-7985-72ce-b39c-71b34a298856.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15098575474393247200&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike---tiempo",
      "poi_latitude": "45.4978048",
      "poi_longitude": "-122.8365767",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl71MV-0OlVQR4G2i9WXqiNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4f7b154d-160c-47b4-8be5-dc61a4233824",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "poi_name": "Tektronix",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13725 SW Karl Braun Dr, Beaverton, OR 97077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-7c67-76a0-a74f-d627fd7fd077.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-7c67-76a0-a74f-d627fd7fd077",
        "storage_key": "property/6767906449166802/019d02d1-7c67-76a0-a74f-d627fd7fd077.webp",
        "width": 1280,
        "height": 531
      },
      "poi_business_url": "https://www.tek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15636940881747062254&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tektronix",
      "poi_latitude": "45.4990886",
      "poi_longitude": "-122.823319",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-833-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-88f1-750a-a895-befa061e449d",
        "storage_key": "property/6767906449166802/019d02d1-88f1-750a-a895-befa061e449d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ679dZUOlVQR7i1RRuKSAdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_4f8f4286-2e5d-446b-8689-438371571604",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_15305710-2999-4d03-b927-a85ece84de2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_3f547f30-29c6-47a6-886c-eea5f321517d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a53dd243-66d4-415b-a724-25cc92996554",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_bfa63959-a82c-4b53-93ff-4aa3a36bb244",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_be3cb1e9-238a-4b58-87ac-ed07b4223181",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "rating": "5",
      "name": "Breonna D.",
      "text": "Management is lovely and got us moved in quickly and filed away fast. Love the space and view for the price! Everyone here is very friendly and it’s very peaceful at night. Some of the best sleep I’ve had in a while 🤣 Love the amenities that come included here as well! Amazingly located and the view in the mornings wow oh wow! 🤯",
      "date": "2026-03-18",
      "title": "false"
    },
    {
      "id": "custom_c1ced2e4-5a14-4a1a-84c2-59cf7811b842",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "rating": "5",
      "name": " Justice K.",
      "text": "Recently moved to Bull Mountain Heights and we love it! The manager, Makena, made the whole process so easy and she’s been so helpful and wonderful. Very happy!",
      "date": "2026-08-28",
      "title": "false"
    },
    {
      "id": "custom_fcdb4fb9-970a-445a-a256-2d8475badea5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "rating": "5",
      "name": "Jacob B. ",
      "text": "Makena and her team are awesome to work with. Really appreciate the warm professionalism.",
      "date": "2026-07-22",
      "title": "false"
    },
    {
      "id": "custom_6b4c1249-f86b-44b4-aa33-2487bbdd7aa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "rating": "5",
      "name": " Gretchen R.",
      "text": "Management & staff are so awesome!\nMaintenance took care of all the small details that needed to be fixed or changed out before I moved in without putting it off later..\nI love my spacious new home!\nGreat team work staff!",
      "date": "2026-05-30",
      "title": "false"
    },
    {
      "id": "custom_a54cf099-6c78-4592-a7b5-c5c3122c2991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "rating": "5",
      "name": " Ashya S.",
      "text": "Loved living here, Makena was great & so helpful with everything my family needed. Recommend moving to Bull Mountain Heights, plus there was so much in nearby cities including restaurants, shopping centers, schools & more.",
      "date": "2026-03-20",
      "title": "false"
    },
    {
      "id": "custom_ae72277e-2bc4-48f5-a494-8df24d4ba730",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "rating": "5",
      "name": "Mary B.",
      "text": "I am always impressed with the response I received from the maintenance staff when I request service. Always professional, prompt and kind when I interact with them.\nThank you",
      "date": "2026-08-31",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_fc2b05d0-8e25-4b41-a6c5-3e1f45ab872c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Discover the Bull Mountain Heights apartments with this immersive walkthrough virtual tour experience with LCP Media",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d2-a1b6-76b9-a6ea-6509f4501dd0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree virtual tour of the apartment property",
        "public_id": "019d02d2-a1b6-76b9-a6ea-6509f4501dd0",
        "storage_key": "property/6767906449166802/019d02d2-a1b6-76b9-a6ea-6509f4501dd0.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Property Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=5c8bb005d1ba7209bfa9debe"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019fa4be-0c38-706c-a64d-cc6e63625498",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Bull Mountain Heights Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "dog-park-apartments-tigard-or",
      "search_query": "dog park apartments tigard or",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Tigard, OR",
      "h2_subtitle": "Find your ideal pet-friendly home at Bull Mountain. Enjoy a community with amenities and a perfect location in Tigard, OR.",
      "page_copy": "Welcome to Bull Mountain, where you and your furry friends can thrive. Our dog park apartments in Tigard, OR, provide a perfect environment for pet lovers. Nestled in the scenic Washington County, our property offers spacious island kitchens, a cozy porch perfect for relaxation, and a modern wet bar ideal for entertaining guests.\n\nOur community encourages sustainable living with easy recycling options and a sprinkler system to keep the surroundings green and lush. Located on Bull Mountain, you're at the heart of a dog-friendly neighborhood, providing plenty of opportunities for walks and play. Experience the perfect blend of convenience and comfort at these inviting pet-friendly apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Tigard, OR",
      "seo_description": "Discover dog park apartments in Tigard, OR at Bull Mountain, featuring pet-friendly amenities and a great location in Washington County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "apartments-with-pool-washington-county",
      "search_query": "apartments with pool in washington county",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Washington County",
      "h2_subtitle": "Experience luxury living at Bull Mountain in Tigard. Our community offers the finest amenities including a pool in Washington County.",
      "page_copy": "Bull Mountain Apartments bring a luxurious touch to living in Washington County, where every day feels like a holiday. Although we don't have a pool, we offer an array of other amenities that make our apartments truly special. Our homes feature beautifully designed island kitchens, perfect for the culinary enthusiast, and a welcoming porch to enjoy tranquil evenings.\n\nWith our eco-friendly recycling options and sophisticated sprinkler system, we ensure a green and sustainable lifestyle. Located in the heart of Tigard, Bull Mountain positions you close to various recreational spots, allowing you to enjoy all that Washington County has to offer. Join a community that values comfort, style, and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Washington County",
      "seo_description": "Explore luxury living at Bull Mountain in Washington County, featuring top-notch amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "in-unit-laundry-bull-mountain-tigard",
      "search_query": "in unit laundry in bull mountain tigard",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry in Bull Mountain, Tigard",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Bull Mountain. Our Tigard community offers modern amenities for an elevated lifestyle.",
      "page_copy": "At Bull Mountain, we prioritize your comfort and convenience with our in-unit laundry facilities, making life easier in Tigard's beautiful Bull Mountain area. Our apartments are designed with modern conveniences, including spacious island kitchens and a charming porch where you can unwind after a busy day.\n\nThe properties also feature environmentally friendly recycling options and a sophisticated sprinkler system, ensuring a sustainable living environment. Nestled in Washington County, Bull Mountain offers a serene yet connected location with convenient access to local amenities. Enjoy the perfect blend of convenience and luxury at our community.\n\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry in Bull Mountain, Tigard",
      "seo_description": "Enjoy in-unit laundry at Bull Mountain in Tigard. Modern amenities and a prime location elevate your living experience in Washington County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "spacious-apartments-dishwasher-97224",
      "search_query": "spacious apartments with dishwasher 97224",
      "category": "Amenity",
      "h1_title": "Spacious Apartments with Dishwasher 97224",
      "h2_subtitle": "Explore our spacious apartments in the 97224 area. Bull Mountain offers modern conveniences like dishwashers for comfortable living.",
      "page_copy": "Discover the ideal home at Bull Mountain, where our spacious apartments include the modern conveniences you desire in the 97224 area. Each apartment is equipped with a stylish dishwasher, making daily chores a breeze and giving you more time to relax. Enjoy the expansive island kitchen, perfect for hosting gatherings, and unwind on your private porch with beautiful views of Tigard.\n\nOur community also features sustainable practices like recycling and a cutting-edge sprinkler system, promoting a green and appealing environment. Situated in the welcoming Bull Mountain neighborhood of Washington County, you'll find the perfect balance of tranquility and accessibility. Experience a lifestyle of ease and comfort at Bull Mountain.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Dishwasher 97224",
      "seo_description": "Find spacious apartments with dishwashers at Bull Mountain in the 97224 area. Modern living in a tranquil Tigard community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-near-sw-bull-mountain-road",
      "search_query": "fitness center apartments near southwest bull mountain road",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments near SW Bull Mountain",
      "h2_subtitle": "Bull Mountain offers a fitness center, and our diverse amenities cater to your lifestyle near Southwest Bull Mountain Road.",
      "page_copy": "Our community offers ample amenities that ensure a cozy and convenient lifestyle. Located near Southwest Bull Mountain Road, our apartments boast elegant island kitchens and inviting porches, perfect for entertaining and relaxation.\n\nOur residents benefit from eco-friendly options such as recycling and a modern sprinkler system that enhances the lush surroundings. Nestled in Tigard's desirable Bull Mountain neighborhood, our location allows easy access to nearby recreational facilities in Washington County. Choose Bull Mountain for a serene living experience with unparalleled convenience and style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments near SW Bull Mountain",
      "seo_description": "Live in comfort near SW Bull Mountain Road with modern amenities at Bull Mountain, close to recreational centers in Tigard.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-tigard-or",
      "search_query": "one bedroom apartments tigard or",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tigard, OR",
      "h2_subtitle": "Discover charming one-bedroom apartments in Tigard, OR at Bull Mountain. Our community offers modern amenities for a comfortable lifestyle.",
      "page_copy": "Welcome to Bull Mountain, where our one-bedroom apartments in Tigard, OR provide the perfect retreat for those seeking both style and comfort. Each unit is thoughtfully designed with a spacious island kitchen, ideal for cooking and entertaining. Residents can also enjoy the peaceful ambiance of their own porch, great for unwinding after a busy day.\n\nOur community embraces sustainable living with features like recycling and an advanced sprinkler system to maintain a green, inviting environment. Located in the serene Bull Mountain neighborhood of Washington County, our apartments offer easy access to local amenities and scenic surroundings, making them a perfect choice for your new home in Tigard, OR.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Tigard, OR",
      "seo_description": "Find your perfect one-bedroom apartment at Bull Mountain in Tigard, OR with modern amenities and a convenient location in Washington County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-bull-mountain",
      "search_query": "two bedroom apartments bull mountain",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Bull Mountain",
      "h2_subtitle": "Find spacious two-bedroom apartments in Bull Mountain. Enjoy modern amenities and a warm community atmosphere in Tigard, OR.",
      "page_copy": "At Bull Mountain, our two-bedroom apartments offer an ideal blend of comfort and modernity in the heart of Tigard, OR. These spacious units feature island kitchens that are perfect for culinary enthusiasts and social gatherings. Each apartment also includes a private porch, adding outdoor charm and tranquility to your living space.\n\nOur community values eco-conscious living, providing amenities like recycling and a state-of-the-art sprinkler system to maintain lush green spaces. Located in the picturesque Bull Mountain neighborhood of Washington County, these apartments provide easy access to local conveniences while being nestled in a peaceful environment. Experience quality living with us in our premium two-bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Bull Mountain",
      "seo_description": "Explore spacious two-bedroom apartments at Bull Mountain in Tigard, OR. Modern amenities and a welcoming community await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166802",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-washington-county",
      "search_query": "three bedroom apartments washington county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Washington County",
      "h2_subtitle": "Discover expansive three-bedroom apartments in Washington County at Bull Mountain, offering a blend of modern amenities and serene living.",
      "page_copy": "Experience upscale living in our three-bedroom apartments at Bull Mountain, located in the heart of Washington County. Each apartment is designed with a functional island kitchen, ideal for meal preparation and dining. The apartments also offer a welcoming porch, allowing residents to enjoy peaceful outdoor moments.\n\nOur commitment to sustainable living is evident through our amenities, which include a recycling program and an efficient sprinkler system, keeping our community green and vibrant. Situated in the Bull Mountain area of Tigard, OR, our complex provides easy access to local attractions and necessary conveniences, ensuring a balanced lifestyle for all residents. Choose Bull Mountain for your next home and indulge in the comfort of our three-bedroom offerings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Washington County",
      "seo_description": "Explore three-bedroom apartments at Bull Mountain in Washington County. Enjoy modern living with spacious layouts and eco-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6004"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005283"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WRG2QQQC"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "561BMT"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('n8nIApaVBU356RBHok')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "41652550782"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw9dge5vo9"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "201210389"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_bullmountain_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Bull Mountain/scheduletourwidget/oHkikM8UMlar98LQoE/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlkwbUNPMmtpOGdtYmlvVjlnbmJSb3c9PSIsInZhbHVlIjoiamYxamRlOUxhSkNFSmIveURIOTFsQT09IiwibWFjIjoiOTMxNDhkNjQxOTY0ZjBjMzliMzM1YWZiOWJmZmFhYjUwMmRmODYyYTA3NGM2ZWZmODBkYmZkNThkNTJjNGM4MSJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6004",
  "custom_repli_id": "10715005283",
  "custom_google_gtm_id": "GTM-WRG2QQQC",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "561BMT",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('n8nIApaVBU356RBHok')</script>",
  "custom_hubspot_company_id": "41652550782",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw9dge5vo9",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "201210389",
  "custom_website_tracking_email": "amcllc_bullmountain_web_propertywebsite@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Bull Mountain/scheduletourwidget/oHkikM8UMlar98LQoE/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlkwbUNPMmtpOGdtYmlvVjlnbmJSb3c9PSIsInZhbHVlIjoiamYxamRlOUxhSkNFSmIveURIOTFsQT09IiwibWFjIjoiOTMxNDhkNjQxOTY0ZjBjMzliMzM1YWZiOWJmZmFhYjUwMmRmODYyYTA3NGM2ZWZmODBkYmZkNThkNTJjNGM4MSJ9",
  "custom_audioeye_site_id": "81247dce-267a-4783-b063-dd34b2503a10",
  "custom_audioeye_site_hash": "ab51bb65107ecbb9a851e0ab15f71cb9"
};

export const generatedAt = '2026-10-08T21:26:26.940Z';
